package ru.it_mozaika.sender.js.application.context

import js.core.jso
import react.*

external interface TableContextInterface {
    var selected: List<String>
    var setSelected: (List<String>) -> Unit
    var toggleSelect: (String) -> Unit
}

val TableContext = createContext<TableContextInterface>(
    jso{
        selected = listOf()
        setSelected = {}
        toggleSelect = {}
    }
)

val TableProvider = FC<PropsWithChildren>{props ->
    val (selected, setSelected ) = useState(listOf<String>())
    TableContext.Provider{
        value = jso{
            this.selected = selected
            this.setSelected = {
                setSelected(it)
            }
            this.toggleSelect = { value ->
                setSelected{current ->
                    if (current.contains(value)) current.minus(value) else current.plus(value)

                }
            }
        }
        + props.children
    }

}
fun useTable() = useContext(TableContext)